import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

import { QuizAnswerTile, TileEventInterface } from './QuizAnswerTile';
import { QuizAnswerRange, RangeSliderEventInterface } from './QuizAnswerRange';

export enum Direction {
    forward = 1,
    back = -1
}

export interface QuestionEventInterface {
    direction:Direction;
    el: QuizQuestion;
    nextRoute: undefined|string;
}

@Component
export class QuizQuestion extends ThemeComponent {
    @Ref({ required: false }) tiles!: QuizAnswerTile[];
    @Ref({ required: false }) rangeSliders!: QuizAnswerRange[];
    @Ref({ required: false }) back!: HTMLButtonElement;
    @Ref() next!: HTMLButtonElement;

    private tileData!:TileEventInterface;
    private rangeSliderData!: RangeSliderEventInterface;
    private texts:string[] = ['Continue to Next Step', 'Find Your Perfect Coffee'];
    private _onChange = new SimpleEvent<QuestionEventInterface>();

    public get onChange() {
        return this._onChange.asEvent();
    }

    init() {
        this.nextClickEvent();

        if (this.back) {
            this.backClickEvent();
        }

        for (const tile of this.tiles) {
            this.$subscribe(tile.onChange, (ev:TileEventInterface) => {
                this.tileData = ev;
                this.handleTiles(ev);
            });
        }

        for (const rangeSlider of this.rangeSliders) {
            this.$subscribe(rangeSlider.onChange, (ev: RangeSliderEventInterface) => {
                this.rangeSliderData = ev;
                this.handleRangeSlider(ev);
            });
        }
    }

    buttonText({ active, nextRoute}:TileEventInterface|RangeSliderEventInterface) {
        if (!active) {
            this.next.setAttribute('disabled', 'disabled');
            this.next.classList.add('button--disabled');
            return;
        }

        this.next.removeAttribute('disabled');
        this.next.classList.remove('button--disabled');

        if (!nextRoute) {
            this.next.textContent = this.texts[1];
            return;
        }

        this.next.textContent = this.texts[0];
    }

    backClickEvent() {
        this.$listen(this.back, 'click', () => {
            this.classList.add('visually-hidden');

            if (this.tileData && this.tileData.active) {
                this.tileData.el.classList.remove('active');
                this.next.setAttribute('disabled', 'disabled');
                this.next.classList.add('button--disabled');
            }

            this._onChange.dispatch({
                direction: Direction.back,
                el: this,
                nextRoute: undefined
            });
        });
    }

    nextClickEvent() {
        this.$listen(this.next, 'click', () => {

            let nextRoute = undefined;

            if (!this.tileData && !this.rangeSliderData) {
                return;
            }

            if (this.tileData) {
                nextRoute = this.tileData.nextRoute;
            }

            if (this.rangeSliderData) {
                nextRoute = this.rangeSliderData.nextRoute;
            }


            this.classList.add('visually-hidden');

            this._onChange.dispatch({
                direction: Direction.forward,
                el: this,
                nextRoute: nextRoute
            });
        });

    }

    handleTiles(ev:TileEventInterface) {
        const { el, active, nextRoute } = ev;

        this.tileData = ev;

        const cleanup = () => {
            if (!active) {
                return;
            }

            for (const tile of this.tiles) {
                if (tile !== el) {
                    tile.classList.remove('active');
                }
            }
        };

        cleanup();
        this.buttonText(ev);
    }

    handleRangeSlider(ev:RangeSliderEventInterface) {
        this.buttonText(ev);
    }
}
